var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge badge-pill float-right",class:_vm.cssClass()},[_vm._v(_vm._s(_vm.I18n.t(("simple_form.labels.billing_task.status." + (this.task_status)))))])}
var staticRenderFns = []

export { render, staticRenderFns }